import type { MessageKey } from 'types/LocaleMessageKey';

import {
  ONE_MONTH_MEMBERSHIP_SELECTED_SUMMARY_KEY,
  ONE_YEAR_MEMBERSHIP_SELECTED_SUMMARY_KEY,
} from '@/app/[locale]/store/_components/HardwarePDP/_hooks/useBuildRingOrder/buildOrderReducer';
import {
  MEMBERSHIP_1MONTH_SKU,
  MEMBERSHIP_1YEAR_SKU,
} from '@/app/[locale]/store/_consts';
import MembershipSelectionEnum from '@/app/enums/MembershipSelectionEnum';

import type getExistingMembership from './getExistingMembership';

export interface GetMembershipSelection {
  value: MembershipSelectionEnum;
  sku: string;
  summaryKey: MessageKey;
}

const getMembershipSelection = (
  lineItem: ReturnType<typeof getExistingMembership>,
): GetMembershipSelection => {
  const sku = lineItem?.skuCode ?? '';

  if (sku === MEMBERSHIP_1YEAR_SKU) {
    return {
      value: MembershipSelectionEnum.OneYear,
      sku,
      summaryKey: ONE_YEAR_MEMBERSHIP_SELECTED_SUMMARY_KEY,
    };
  } else {
    return {
      value: MembershipSelectionEnum.OneMonth,
      sku: MEMBERSHIP_1MONTH_SKU,
      summaryKey: ONE_MONTH_MEMBERSHIP_SELECTED_SUMMARY_KEY,
    };
  }
};

export default getMembershipSelection;
